import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { useEffect, useState } from 'react';
import { AccordionPanel } from './accordion_panel.component';
export const Accordion = ({ panels = [], onToggle, singleActivePanel = true }) => {
    const [openAccordions, setOpenAccordions] = useState({});
    useEffect(() => {
        if (singleActivePanel) {
            let lastOpenIdx;
            panels.forEach((panel, index) => {
                if (!panel.disabled && panel.initialIsOpen) {
                    lastOpenIdx = index;
                }
            });
            if (lastOpenIdx !== undefined) {
                setOpenAccordions({ [lastOpenIdx]: true });
            }
        }
        else {
            setOpenAccordions(panels.reduce((acc, { initialIsOpen, disabled }, index) => {
                acc[index] = !disabled && !!initialIsOpen;
                return acc;
            }, {}));
        }
    }, [panels, singleActivePanel]);
    const onAccordionToggle = (value, index) => {
        const newOpenAccordions = singleActivePanel ? { [index]: value } : Object.assign(Object.assign({}, openAccordions), { [index]: value });
        setOpenAccordions(newOpenAccordions);
        if (onToggle) {
            onToggle(value, index);
        }
    };
    return (_jsx("section", { children: panels.map((_a, index) => {
            var { id } = _a, accordionProps = __rest(_a, ["id"]);
            const panelId = id || `${accordionProps.title}-${index}`;
            return (_createElement(AccordionPanel, Object.assign({}, accordionProps, { onToggle: (value) => onAccordionToggle(value, index), isOpen: openAccordions[index], key: panelId, panelId: panelId })));
        }) }));
};
//# sourceMappingURL=accordion.component.js.map